import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/login")({
  beforeLoad: ({ context: { sessionData } }) => {
    if (sessionData !== null) {
      throw redirect({ to: "/app", replace: true, statusCode: 307 });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
